// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1iqWd","edit":"_2DYK8","heading":"_1AML6","amount":"_3Nzo2"};